var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlecheDroite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    className: "mainStroke",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.917 17.226c-.292.106-.5.39-.5.68 0 .274.196.49 3.06 3.36l3.06 3.067h-9.509c-9.071 0-9.518.007-9.697.152-.265.215-.265.815 0 1.03.179.145.626.152 9.697.152h9.509l-3.06 3.067c-2.864 2.87-3.06 3.086-3.06 3.36 0 .545.566.868 1.022.583.148-.093 1.891-1.793 3.874-3.779 3.354-3.36 3.604-3.631 3.604-3.898 0-.267-.247-.534-3.521-3.819-1.937-1.943-3.667-3.641-3.846-3.773-.328-.243-.406-.266-.633-.182",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheDroite);
export default __webpack_public_path__ + "static/media/fleche-droite.7de819fdda2037075f645af7b25459c5.svg";
export { ForwardRef as ReactComponent };